import { LOCATION_CHANGE } from "connected-react-router";

const initialState = [];

const history = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      return [...state, action.payload];
    default:
      return state;
  }
};

export default history;
